import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';

import { ModelPlainMapOf } from '@technocom/common/data';
import { EntityProvider } from '@technocom/data';
import { AbstractState } from '@app/shared/abstract.state';
import { Citizenship } from '@app/shared/models/dictionaries/citizenship';
import { GetCitizenship, GetPurpose, GetResidence } from '@app/shared/app.action';
import { Purpose } from '@app/shared/models/dictionaries/purpose';
import { Residence } from '@app/shared/models/dictionaries/residence';

export interface AppStateModel {
  citizenship: Array<ModelPlainMapOf<Citizenship>>;
  purpose: Array<ModelPlainMapOf<Purpose>>;
  residence: Array<ModelPlainMapOf<Residence>>;
}

@State<AppStateModel>({
  name: 'app',
  defaults: {
    citizenship: [],
    purpose: [],
    residence: [],
  },
})
@Injectable()
export class AppState extends AbstractState<AppStateModel> {
  constructor(entityProvider: EntityProvider) {
    super(entityProvider);
  }

  @Action(GetCitizenship, { cancelUncompleted: true })
  fetchCitizenships(ctx: StateContext<AppStateModel>) {
    return this.queryDictionary(Citizenship, ctx, 'citizenship');
  }
  @Action(GetPurpose, { cancelUncompleted: true })
  fetchPurpose(ctx: StateContext<AppStateModel>) {
    return this.queryDictionary(Purpose, ctx, 'purpose');
  }
  @Action(GetResidence, { cancelUncompleted: true })
  fetchResidence(ctx: StateContext<AppStateModel>) {
    return this.queryDictionary(Residence, ctx, 'residence');
  }

  @Selector([AppState])
  static getCitizenships(state: AppStateModel) {
    return state.citizenship;
  }

  @Selector([AppState])
  static getPurpose(state: AppStateModel) {
    return state.purpose;
  }

  @Selector([AppState])
  static getResidence(state: AppStateModel) {
    return state.residence;
  }
}
